<template>
  <section class="container">
    <CoolLightBox 
      :items="items" 
      :index="index"
      loop
      @close="index = null">
    </CoolLightBox>
    <full-page ref="fullpage" :options="options">
      <div
        class="section"
        id="section1raak"
        data-anchor="raak1"
        style="margin-bottom:15px;"
      >
        <div class="fp-bg"></div>
        <div class="headerProyecto-raak" id="headerProy">
          <v-container fluid>
            <v-row>
              <v-col cols="2"></v-col>
              <v-col cols="6">
                <v-row>
                  <div
                    class="titulo-proyecto-raak"
                    style="position: absolute; font-family: 'Didot-bold'; color: black !important; font-size: calc(14.5px + 2.18125vw); z-index: 9999; opacity: 1;"
                  >
                    <p>Gimnasio RAAK</p>
                  </div>
                </v-row>
                <v-row>
                  <div
                    style="position: relative; top:25vh; left: 10vw; font-family: 'Source'; color: black; font-size: calc(10.5px + 1.08125vw);"
                  >
                    Interiorismo e instalación
                  </div>
                </v-row>
                <v-row>
                  <div
                    style="position: relative; top:25vh; left: 10vw; font-family: 'Source'; color: black; font-size: calc(6.5px + 0.8125vw);">
                    Proyecto no ejectuado - Solo propuesta de diseño
                  </div>
                </v-row>
                <v-row>
                  <div
                    style="position: relative; top:25vh; left: 10vw; font-family: 'Source'; color: black; font-size: calc(8.5px + 1.08125vw);"
                  >
                    Santiago 2020
                  </div>
                </v-row>
                <v-row>
                  <v-btn class="boton-volver-raak" to="/proyectos"
                    >Volver</v-btn
                  >
                  <!--           <div>
                  <v-icon large style="position:absolute; bottom:1vh; left: 50vw; transition: all 0.45s ease-in-out;" @click="toggleCabProy()" v-if="cabeceraIsVisible" color="#372b5d">mdi-chevron-up</v-icon>
                  <v-icon large style="position:absolute; bottom:1vh; left: 50vw; transition: all 0.45s ease-in-out;" @click="toggleCabProy()" v-if="!cabeceraIsVisible" color="#372b5d">mdi-chevron-down</v-icon>
                  </div>-->
                </v-row>
              </v-col>
              <v-col cols="4"></v-col>
            </v-row>
          </v-container>
        </div>

        <div class="slide" id="slide1-3">
          <div class="fp-bg"></div>
        </div>

      </div>

      <div class="section" id="section2raak" data-anchor="raak2">
        <v-container fluid>
          <v-row>
            <v-col cols="6">
              <v-img :src="image_srcraak3" class="img-raak3" contain @click="setIndex(2)"
                ><template v-slot:placeholder>
                  <v-row
                    class="fill-height ma-0"
                    align="center"
                    justify="center"
                  >
                    <v-progress-circular
                      indeterminate
                      color="black"
                    ></v-progress-circular>
                  </v-row> </template
              ></v-img>
            </v-col>

            <v-col cols="6">
              <div class="fondo-grisraak">
                <v-row class="row1raak">
                  <v-col cols="2">
                    <p class="programa-raak">Programa</p>
                    <br />
                  </v-col>
                  <v-col
                    cols="10"
                    style="padding-left: 3vw;"
                    class="textocol1-raak"
                  >
                    <p class="texto1raak">
                      Interiorismo de espacios de spa, baños y camarines.
                      Proyecto de iluminación y propuesta de instalación a
                      escala humana
                    </p>

                    <p class="texto1raak"></p>
                  </v-col>
                </v-row>
                <v-row class="row2raak">
                  <v-col cols="2">
                    <p class="programa-raak">Colaboradores</p>
                    <br />
                  </v-col>
                  <v-col
                    cols="10"
                    style="padding-left: 3vw;"
                    class="textocol1-raak"
                  >
                    <p class="texto1raak">
                      Arquitectura Constructiva

                      <br />
                      <br />Iluminación
                      <br />
                      <a
                        href="https://www.instagram.com/estudioamani/"
                        target="_blank"
                        style="font-family: 'Source-bold'; font-color: #372b5d !important;"
                      >
                        @estudioamani
                      </a>

                      <br />
                      <br />Soldador especialista <br /><a
                        href="https://www.instagram.com/iracundataller/"
                        target="_blank"
                        style="font-family: 'Source-bold'; font-color: #372b5d !important;"
                      >
                        @iracundataller</a
                      >
                    </p>

                    <p class="texto1"></p>
                  </v-col>
                </v-row>
                <v-row class="row3raak">
                  <v-col cols="2">
                    <p class="programa-raak">Superficie</p>
                    <br />
                  </v-col>
                  <v-col
                    cols="10"
                    style="padding-left: 3vw;"
                    class="textocol1-raak"
                  >
                    <p class="texto1raak">300 m2</p>
                  </v-col>
                </v-row>
              </div>
            </v-col>
          </v-row>
        </v-container>
      </div>

      <div class="section" id="section3raak" data-anchor="raak3">
        <v-container fluid>
          <v-row>
            <v-col cols="6">
              <v-img :src="image_srcraak1" class="img-raak4" contain @click="setIndex(0)"
                ><template v-slot:placeholder>
                  <v-row
                    class="fill-height ma-0"
                    align="center"
                    justify="center"
                  >
                    <v-progress-circular
                      indeterminate
                      color="black"
                    ></v-progress-circular>
                  </v-row> </template
              ></v-img>
            </v-col>
            <v-col cols="6">
              <div class="fondo-gris2raak">
                <v-row>
                  <p class="texto2raak">
                    La propuesta tiene como finalidad generar un espacio único y
                    atractivo, plasmando un estilo minimalista/industrial para
                    crear una experiencia que integre diversas funciones.
                  </p>
                </v-row>
                <v-row>
                  <p class="texto2raak">
                    Dentro del encargo se pide Incorporar un elemento de impacto
                    visual en vacío central proponiéndose un estructura trepable
                    que une todos los pisos a través de un vacío central.
                  </p>
                </v-row>
              </div>
            </v-col>
            <v-col cols="1"></v-col>
          </v-row>
        </v-container>
      </div>

      <div class="section" id="section4raak" data-anchor="raak4">
        <v-container fluid>
          <v-row>
            <v-col cols="12">
              <v-img :src="image_srcraak2" class="img-raak2" cover @click="setIndex(1)"
                ><template v-slot:placeholder>
                  <v-row
                    class="fill-height ma-0"
                    align="center"
                    justify="center"
                  >
                    <v-progress-circular
                      indeterminate
                      color="black"
                    ></v-progress-circular>
                  </v-row> </template
              ></v-img>
            </v-col>
          </v-row>
        </v-container>
      </div>
    </full-page>
  </section>
</template>

<script>
import store from "../store";
import CoolLightBox from 'vue-cool-lightbox'
import 'vue-cool-lightbox/dist/vue-cool-lightbox.min.css'

export default {
  data() {
    return {
      proyectos: [
        {
          numero: 3,
          numeroString: "03",
          isActive: false,
          route: "/raak",
          titulo: "Gimnasio RAAK",
          resumen: "Interiorismo e instalación",
          lugar: "Santiago",
          año: "2020",
          programa:
            "Interiorismo de espacios de spa, baños y camarines. Proyecto de iluminación y propuesta de instalación a escala humana",
          colaboradores: ["@estudioamani", "@iracundataller"],
          superficie: "26 m2",
          descripcion: [
            "Creamos este espacio con una arquitectura que reúne la cultura japonesa y hawaiana, creando una fusión de éstas. Se proyectó un mural en frente de la barra que le diere carácter al espacio. Una gran pintura hecha a mano que evoca la gran ola de KANAGAWA, por otra parte, en el techo se instalaron lámparas de grandes peces de origami. Otro sello distintivo del proyecto, es la barra en donde se ubica una pequeña laguna en donde hay patitos de goma que pueden pescarse con una caña mientras te instalas a comer."
          ]
        }
      ],
      items: [
        {
          src: require("../assets/raak1.jpg"),
        },
        {
          src: require("../assets/raak2.jpg"),
        },
        {
          src: require("../assets/raak3.jpg"),
        },
      ],
      index: null,
      posicionLista: -25,
      proyectoSeleccionado: 3,
      image_srcraak1: require("../assets/raak1.jpg"),
      image_srcraak2: require("../assets/raak2.jpg"),
      image_srcraak3: require("../assets/raak3.jpg"),
      options: {
        licenseKey: "265864DA-1DE54052-9BEBB977-EF50CFB8",
        parallax: true,
        parallaxKey: [
          "Y29sZWN0aXZvYWxxdWltaWEuY2xfYmxNY0dGeVlXeHNZWGc9OTJR",
          "Y29sZWN0aXZvLWFscXVpbWlhLndlYi5hcHBfdjhXY0dGeVlXeHNZWGc9QVEw",
          "Y29sZWN0aXZvLWFscXVpbWlhLndlYi5hcHBfNjI0Y0dGeVlXeHNZWGc9WVlP"
        ],
        // parallaxKey: '7CD7B03B-68104BF5-88FFE8B4-2585F4CC',
        // activation-key for domain colectivoalquimia.cl: Y29sZWN0aXZvYWxxdWltaWEuY2xfcmg0Y0dGeVlXeHNZWGc9bHhi
        autoScrolling: true,
        scrollbar: false,
        slidesNavigation: false,
        controlArrows: false,
        verticalCentered: false,
        anchors: ["raak1", "raak2", "raak3", "raak4"],
        bigSectionsDestination: "top",
        scrollingSpeed: "700",
        parallaxOptions: {
          type: "cover",
          percentage: 99,
          property: "translate"
        },
        onLeave: function(origin, destination, direction) {
          console.log(destination);
          console.log(direction);
          if (origin.index == 0) {
            store.commit("esconder");
            document.getElementById("headerProy").style.top = "-60vh";
          } else if (origin.index == 1 && direction == "up") {
            //document.getElementById("headerProy").style.top = "0vw";
            // store.commit("mostrar");
          }
        },
        afterLoad: function(origin, destination, direction) {
          console.log(destination);
          console.log(direction);
          if (origin.index == 0) {
            setTimeout(function() {
              document.getElementById("headerProy").style.top = "0vh";
            }, 2000);
          } else if (origin.index == 1 && direction == "up") {
            //document.getElementById("headerProy").style.top = "0vw";
            // store.commit("mostrar");
          }
        }
      }
    };
  },
  components: {
    CoolLightBox
  },
  metaInfo: {
    title: "Proyectos",
    titleTemplate: "%s | Gimnasio RAAK"
  },
  computed: {
    yLista() {
      return `transform: translateY(${this.posicionLista}%)`;
    }
  },
  mounted() {
    setTimeout(function() {
      document.getElementById("headerProy").style.top = "-60vh";
    }, 2000);
    this.$refs.fullpage.api.moveTo(1, 0);
  },
  methods: {
    isOnTop() {
      if (this.$refs.fullpage.api.getActiveSection().anchor == "pro1") {
        return true;
      } else {
        return false;
      }
    },
    setIndex(index) {
      this.index = index;
    },
    getSection() {
      return this.$refs.fullpage.api.getActiveSection().anchor;
    },
    getSectionIndex() {
      return this.$refs.fullpage.api.getActiveSection().index;
    },
    selectTitle() {
      this.$refs.fullpage.api.moveTo(2);
    }
  }
};
</script>

<style>
.fp-bg {
  background-size: cover;
  transform: translate3d(0, 0, 0);
  -webkit-backface-visibility: hidden; /* Chrome, Safari, Opera */
  backface-visibility: hidden;
}
.container {
  padding: 0px;
  margin: 0px;
  transition: all 0.45s ease-in-out;
  transition: all 0.45s cubic-bezier(0.55, 0, 0.1, 1);
}
.section {
  height: 100vh;
  z-index: -1;
}
#section1raak {
  background-image: url("../assets/raak1.jpg");
  background-size: cover;
  background-position: center 50%;
}
#section4raak {
  background-size: cover;
}
#slide1-1 .fp-bg {
  background-image: url("../assets/1.jpg");
  background-size: cover;
  background-position: center 80%;
}
#slide1-2 .fp-bg {
  background-image: url("../assets/2.jpg");
  background-size: cover;
  background-position: center 80%;
}
#slide1-3 .fp-bg {
  background-image: url("../assets/3.jpg");
  background-size: cover;
  background-position: center 80%;
}
#slide1-4 .fp-bg {
  background-image: url("../assets/4.jpg");
  background-size: cover;
  background-position: center 80%;
}
.titulo-apiadate {
  position: absolute;
  height: 6vw;
  top: 40vh;
  padding: 0em;
  font-size: calc(14.5px + 2.98125vw);
  font-family: "Source-bold";
  color: white;
  text-decoration: none;
  text-shadow: 0px 0px #000000;
  transition-duration: 625ms;
  transition: opacity 0.5s, transform 0.5s;
  z-index: 99;
}
.headerProyecto-raak {
  position: fixed;
  top: 0;
  background-color: #fff;
  height: 60vh;
  width: 100%;
  transition: 925ms;
  z-index: 999;
}

@media (min-width: 960px) {
  .texto1raak {
    font-size: calc(4.5px + 1.01875vw);
    color: black;
    padding-left: 10px;
    padding-right: 5vw;
    font-family: "Source";
  }
  .texto2raak {
    top: 5vh;
    font-size: calc(2.5px + 1.01875vw);
    color: black;
    padding-right: 1vw;
  }
  .img-raak2 {
    top: 1vh;
    left: 15vw;
    width: 65vw;
    cursor: pointer;
  }
  .img-raak3 {
    top: 1px;
    left: 5vw;
    padding-left: 10vw;
    margin-bottom: 1vh;
    width: 41vw;
    cursor: pointer;
  }
  .img-raak4 {
    position: absolute;
    bottom: 0vh;
    left: 1vw;
    padding: 5vw;
    width: 50vw;
    z-index: 1;
    cursor: pointer;
  }
  .img-raak5 {
    position: absolute;
    cursor: pointer;
    right: 5vw;
    padding: 5vw;
    width: 40vw;
    z-index: 1;
  }
  .programa-raak {
    color: black;
    white-space: pre;
    font-size: calc(4.5px + 0.68125vw);
  }
  .fondo-grisraak {
    position: absolute;
    background-color: #e3dfe0 !important;
    right: 8vw;
    top: 1vh;
    margin-top: 0;
    max-width: 38vw;
    height: 55vh;
    padding-left: 1vw;
    padding-right: 0vw;
    padding-top: 0px;
    padding-bottom: 0px;
  }
  .fondo-gris2raak {
    left: 5vw;
    position: relative;
    background-color: #e3dfe0 !important;
    right: 5vw;
    padding-left: 3vw;
    padding-right: 1vw;
    margin-right: 5vw;
    max-width: 37vw;
    min-height: 40vh;
    max-height: 80vh;
    padding-top: 50px;
    padding-bottom: 1vh;
  }
  .proyectos {
    position: fixed;
    top: 55vh;
    width: 50vw;
    left: 15vw;
    z-index: 99;
    transition-duration: 625ms;
    transition: opacity 0.5s, transform 0.5s;
  }
  li {
    height: 6vw;
  }
  .row1raak {
    position: relative;
    height: 18vh;
  }
  .row2raak {
    position: relative;
    height: 30vh;
  }
  .row3raak {
    position: relative;
    height: 5vh;
  }
  .nProyecto {
    position: relative;
    bottom: 6vh;
    font-size: calc(30.5px + 2.8125vw);
    font-family: "Source";
    display: inline-block;
    width: 120px;
    padding-bottom: 0px;
    margin-bottom: 0px;
    transition: opacity 0.5s, transform 0.5s;
  }
  .nTotalProyectos {
    position: fixed;
    bottom: 5vh;
    left: 15vw;
    font-size: calc(30.5px + 2.8125vw);
    font-family: "Source";
    display: inline-block;
    width: 120px;
    padding-bottom: 0px;
    margin-bottom: 0px;
    color: white;
    transition: opacity 0.5s, transform 0.5s;
    z-index: 99;
    opacity: 0.5;
  }
  .titulo-proyecto-raak {
    position: absolute;
    font-family: "Didot-bold";
    color: black;
    font-size: calc(14.5px + 2.18125vw);
    top: 15vh;
    left: 25vw;
  }
  .titulo-proyecto-raak::before {
    content: "";
    position: absolute;
    top: 35px;
    right: 100%;
    cursor: default;
    width: 1.5em;
    height: 3px;
    background: #000;
    z-index: 3;
  }
  .subtitulo-proyecto {
    font-family: "Source";
    font-size: calc(10.5px + 1.78125vw);
  }
  .texto-card {
    font-family: "Source";
    font-size: 20px;
    font-weight: 400;
    padding-top: 20px;
    color: #ffffff;
    line-height: 1;
  }
  .boton-volver-raak {
    position: absolute;
    font-family: "Source";
    bottom: 3vh;
    left: 25vw;
    z-index: 9999;
  }
}

@media (max-width: 960px) {
  .texto1raak {
    position: relative;
    top: 5vh;
    font-size: calc(7.5px + 0.91875vw);
    color: black;
    padding: 0;
    max-width: 40vw;
    padding-top: 0vh;
    margin-left: 0vw;
    padding-left: 0vw;
  }
  .texto2raak {
    top: 5vh;
    font-size: calc(6.5px + 1.01875vw);
    color: black;
    padding-right: 0vw;
    padding: 0;
    max-width: 50vw;
    padding-top: 0vh;
    margin-left: 0vw;
    padding-left: 0vw;
  }
  .boton-volver {
    position: absolute;
    font-family: "Source";
    bottom: 20vw;
    left: 5vw;
    z-index: 9999;
  }
  .img-raak {
    top: 20vh;
    right: 0vw;
    position: absolute;
    width: 0vw;
    z-index: 0;
  }
  .img-raak2 {
    top: 20vh;
    right: 0vw;
    position: absolute;
    width: 100%;
    z-index: 0;
  }
  .img-raak3 {
    top: 5vh;
    left: 20vw;
    height: 0vh;
  }
  .img-raak4 {
    position: absolute;
    height: 0vh;
  }
  .img-raak5 {
    position: absolute;
    bottom: 20vh;
    right: 2vw;
    padding: 5vw;
    height: 0vh;
    z-index: 1;
  }
  #section2raak {
    background-image: url("../assets/raak1.jpg");
    background-size: cover;
    background-position: center 10%;
  }
  #section3raak {
    background-image: url("../assets/raak3.jpg");
    background-size: cover;
    background-position: center 10%;
  }
  .fondo-grisraak {
    position: relative;
    top: 0;
    right: 5vw;
    background-color: #e3dfe0 !important;
    min-width: 70vw;
    margin-top: 10vh;
    max-height: 80vh;
    padding-top: 5px;
    padding-right: 15px;
    z-index: 5;
  }
  .fondo-gris2raak {
    position: relative;
    background-color: #e3dfe0 !important;
    min-height: 45vh;
    height: 40vh;
    max-width: 70vw;
    padding: 7vw;
    margin-top: 10vh;
    padding-bottom: 2vh;
    top: 20vh;
    right: 5vw;
  }
  .row1raak {
    position: relative;
    margin-top: 1px;
    min-height: 5vh;
  }
  .row2raak {
    position: relative;
    margin-top: 1px;
    min-height: 15vh;
  }
  .row3raak {
    position: relative;
    bottom: 0;
    margin-top: 1px;
    min-height: 5vh;
  }
  .textocol1-raak {
    line-height: 1.5;
  }
  .programa-raak {
    position: relative;
    top: 0vh;
    padding-left: 2vw;
    color: black;
    white-space: pre;
    font-size: calc(4.5px + 1.98125vw);
  }
  .proyectos {
    position: fixed;
    top: 60vh;
    width: 50vw;
    left: 15vw;
    z-index: 99;
    white-space: nowrap;
    transition-duration: 625ms;
    transition: opacity 0.5s, transform 0.5s;
  }
  li {
    white-space: nowrap;
  }
  .nProyecto {
    position: relative;
    bottom: 4vh;
    font-size: calc(30.5px + 2.8125vw);
    font-family: "Source";
    display: inline-block;
    width: 60px;
    padding-bottom: 0px;
    margin-bottom: 0px;
    transition: opacity 0.5s, transform 0.5s;
  }
  .nTotalProyectos {
    position: fixed;
    bottom: 15vh;
    left: 15vw;
    font-size: calc(30.5px + 2.8125vw);
    font-family: "Source";
    display: inline-block;
    width: 120px;
    padding-bottom: 0px;
    margin-bottom: 0px;
    color: white;
    transition: opacity 0.5s, transform 0.5s;
    z-index: 99;
    opacity: 0.5;
  }
  .titulo-proyecto-raak {
    position: absolute;
    font-family: "Didot-bold";
    color: black;
    font-size: calc(20.5px + 2.18125vw);
    top: 20vh;
    left: 25vw;
  }

  .subtitulo-proyecto {
    font-family: "Source";
    font-size: calc(10.5px + 1.78125vw);
  }
  .texto-card {
    font-family: "Source";
    font-size: 20px;
    font-weight: 400;
    padding-top: 20px;
    color: #000000;
    line-height: 1;
  }
  .boton-volver-raak {
    position: relative;
    font-family: "Source";
    top: 50vw;
    left: 10vw;
    z-index: 9999;
  }
}
</style>
